import { useEffect, useMemo } from "react";

import {
  createWorkFlowUser,
  getWorkFlowUserWorkflow,
  removeWorkFlowUser
} from "@/api/workflow-user";
import { useNavigate } from "react-router-dom";
import { SessionType } from "@/types/session";
import { useSession } from "@/hooks/server-state/use-session";
import { useActiveRoleStore } from "@/hooks/store/use-active-role-store";

const DashboardHomePage = () => {
  const navigate = useNavigate();
  const { data: session, isLoading } = useSession();
  const { activeRoleId } = useActiveRoleStore();

  const activeRole = useMemo(() => {
    const roles = (session as SessionType | null)?.roles ?? [];

    return activeRoleId
      ? (roles.find((role) => role.id.toString() === activeRoleId) ?? null)
      : (roles[0] ?? null);
  }, [activeRoleId, session]);

  useEffect(() => {
    if (isLoading) {
      return;
    }

    const workflowId = activeRole?.workflowId;
    const nodeId = activeRole?.nodeId;

    if (!workflowId || !nodeId) {
      navigate("/dashboard/menu", { replace: true });
      return;
    }

    let isMounted = true;

    const routeToWorkflow = async () => {
      const existingWorkflowUser = await getWorkFlowUserWorkflow(workflowId);

      if (!isMounted) {
        return;
      }

      if (existingWorkflowUser?.data?.id) {
        await removeWorkFlowUser(+existingWorkflowUser.data.id);
      }

      const createdWorkFlowUser = await createWorkFlowUser({
        workFlowId: workflowId,
        nodeId
      });

      if (!isMounted || !createdWorkFlowUser?.data?.id) {
        return;
      }

      navigate(`/dashboard/workflow-form/${createdWorkFlowUser.data.id}`, {
        replace: true
      });
    };

    routeToWorkflow().catch(() => {
      if (isMounted) {
        navigate("/dashboard/menu", { replace: true });
      }
    });

    return () => {
      isMounted = false;
    };
  }, [activeRole?.nodeId, activeRole?.workflowId, isLoading, navigate]);

  return null;
};

export default DashboardHomePage;